import { Box, Skeleton, Stack } from '@mui/material';

const ChatSkeletonLoader = ({ count = 4 }) => {
    const skeletons = Array.from({ length: count });

    return (
        <Stack spacing={2} sx={{ padding: 2 }}>
            {skeletons.map((_, index) => {
                const isLeft = index % 2 === 0; // alternate messages
                return (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: isLeft ? 'flex-start' : 'flex-end',
                        }}
                    >
                        <Box
                            sx={{
                                // bgcolor: 'white',
                                padding: 1.5,
                                borderRadius: 2,
                                boxShadow: 3,
                                maxWidth: '200px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                            }}
                        >
                            <Skeleton variant="text" width={50} height={20} />
                            <Skeleton variant="text" width={40} height={16} />
                        </Box>
                    </Box>
                );
            })}
        </Stack>
    );
};

export default ChatSkeletonLoader;
